import axios from 'axios';
import { get } from 'lodash-es';

/**
 * @returns {Promise<Array<import('../api-component/types/api-keys').APIKeysV1>>}
 */
export const getSellerV1ApiKeys = async () => {
  const response = await axios.get('/account/getallsellerapikeys');
  const result = get(response, 'data') || [];
  return result;
};

/**
 * @param {number} apiKeyId
 * @returns {Promise<void>}
 */
export const deleteSellerV1ApiKey = async (apiKeyId) => {
  const response = await axios.post('/account/deletesellerapikeys2', {
    keyId: apiKeyId,
  });
  const result = get(response, 'data');
  return result;
};

/**
 * @param {object} payload
 * @param {string} payload.expiryDateTime
 * @returns {Promise<import('../api-component/types/api-keys').APIKeysV1>}
 */
export const generateSellerV1ApiKey = async (payload) => {
  const response = await axios.post('/account/createsellerapikeys2', payload);
  const result = get(response, 'data');
  return result;
};

/**
 * @returns {Promise<import('../api-component/types/api-keys').APIKeysV2>}
 */
export const generateV2SellerApiKeys = async () => {
  const response = await axios.post('/account/v2/generateSellerApiKeys2', {
    headers: { 'Content-Type': 'application/json' },
  });
  const result = get(response, 'data');
  return result;
};

/**
 * @returns {Promise<import('../api-component/types/api-keys').APIKeysV2>}
 */
export const getV2SellerApiKeys = async () => {
  const response = await axios.get('/account/v2/getSellerApiKeys');
  const result = get(response, 'data');
  return result;
};

/**
 * @param {string} encryptedApiKey
 * @returns {Promise<void>}
 */
export const deleteV2SellerApiKey = async (encryptedApiKey) => {
  const response = await axios.delete('/account/v2/disableApiKey2', {
    data: { encryptedApiKey },
  });
  const result = get(response, 'data');
  return result;
};
